export default __webpack_public_path__ + "static/media/colorGithub.04c1b3f7.svg";